import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuildingSelected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.7637 2.0126C11.447 1.32913 12.5549 1.32913 13.2383 2.0126L21.986 10.7626C23.0881 11.8649 22.3078 13.75 20.7487 13.75H19.6676C19.3915 13.75 19.1676 13.9739 19.1676 14.25V21C19.1676 21.8284 18.4961 22.5 17.6676 22.5H15V17C15 15.8954 14.1046 15 13 15H11C9.89543 15 9 15.8954 9 17V22.5H6.33431C5.50589 22.5 4.83431 21.8284 4.83431 21V14.25C4.83431 13.9739 4.61046 13.75 4.33431 13.75H3.25324C1.69419 13.75 0.913858 11.8649 2.01594 10.7626L10.7637 2.0126ZM11 22.5H13V17H11V22.5Z",
		fill: "#0FAFAF"
	})
});
export default SvgBuildingSelected;
